export const ErrorCode = {
  0: "ALARM_USB_INVALID",
  1: "ALARM_CPU_HIGH",
  2: "ALARM_MEMORY_HIGH",
  3: "ALARM_KBWRUTEDISK_HIGH",
  4: "ALARM_KBREADDISK_HIGH",
  5: "ALARM_STORAGEROOT_HIGH",
  6: "ALARM_STORAGETMPFS_HIGH",
  7: "ALARM_SERVICE_EXPIRED",
  8: "ALARM_SW_WD_EXPIRED",
  9: "ALARM_BATTERY_REMOVED",
  10: "ALARM_DIAL_ERROR",
  11: "ALARM_AUTO_TIME_INVALID",
  12: "ERRORE_MODULO_INDIRIZZO",
  13: "ALARM_BATTERY_FAULT",
  14: "ALARM_CONNECTION_MODEM_ISSUE",
  15: "POWER_DISCONNECTED",
  16: "RTC_INVALID",
};
